import { Link } from "react-router-dom";
import { Instagram } from "lucide-react";
import { Logo } from "./Logo";

const TikTokIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" {...props}>
    <path d="M16.5 3c.3 2.1 1.5 3.6 3.5 3.9v2.4c-1.2.1-2.4-.2-3.5-.8v5.9c0 3-2 5.1-4.9 5.1-2.7 0-4.6-1.8-4.6-4.4 0-2.6 2-4.4 4.5-4.4.3 0 .6 0 .9.1v2.5a2 2 0 0 0-1-.2c-1.1 0-2 .8-2 1.9s.8 2 2 2 2-.9 2-2.1V3h2.6Z" />
  </svg>
);

const SOCIALS = [
  { label: "Instagram", href: "https://www.instagram.com/monoepay", Icon: Instagram, testId: "footer-social-instagram" },
  { label: "TikTok", href: "https://www.tiktok.com/@monoepay", Icon: TikTokIcon, testId: "footer-social-tiktok" },
];

const COLS = [
  {
    title: "Platform",
    links: [
      { label: "Customers", to: "/customers" },
      { label: "Businesses", to: "/business" },
      { label: "Discover", to: "/discover" },
      { label: "Rewards", to: "/rewards" },
      { label: "Restaurants", to: "/restaurants" },
      { label: "Enterprise", to: "/enterprise" },
      { label: "About", to: "/about" },
      { label: "Contact", to: "/contact" },
    ],
  },
  {
    title: "Legal",
    links: [
      { label: "Legal Center", to: "/legal" },
      { label: "Terms of Service", to: "/legal/terms" },
      { label: "Privacy Policy", to: "/legal/privacy" },
      { label: "Rewards & Credits Terms", to: "/legal/rewards" },
    ],
  },
];

export const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-border bg-background">
    <div className="mx-auto max-w-7xl px-4 py-14 sm:px-6 lg:px-8">
      <div className="grid gap-10 md:grid-cols-4">
        <div className="md:col-span-2">
          <Logo />
          <p className="mt-4 max-w-sm font-display text-base font-semibold leading-snug text-foreground">
            MONOE · The space where business meets life.
          </p>
          <p className="mt-3 max-w-sm text-sm leading-relaxed text-muted-foreground">
            One app for the local businesses around you — discover, order, split, tip, pay, and earn
            dollar rewards. Currently in development and preparing for launch.
          </p>
          <a
            href="mailto:support@monoepay.com"
            data-testid="footer-support-email"
            className="mt-4 inline-block font-mono-ui text-sm text-foreground underline underline-offset-4"
          >
            support@monoepay.com
          </a>
          <div className="mt-5 flex items-center gap-3">
            {SOCIALS.map((s) => (
              <a
                key={s.label}
                href={s.href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={s.label}
                data-testid={s.testId}
                className="grid h-9 w-9 place-items-center rounded-md border border-border text-foreground transition-colors hover:bg-accent"
              >
                <s.Icon className="h-4 w-4" />
              </a>
            ))}
          </div>
        </div>
        {COLS.map((col) => (
          <div key={col.title}>
            <p className="eyebrow text-muted-foreground">{col.title}</p>
            <ul className="mt-4 space-y-2.5">
              {col.links.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                    className="text-sm text-muted-foreground transition-colors hover:text-foreground"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className="mt-12 border-t border-border pt-6">
        <p className="max-w-3xl text-xs leading-relaxed text-muted-foreground">
          MONOE Pay LLC is a commerce technology provider and is not a bank or depository
          institution. MONOE does not hold customer funds directly. Split Bill is not a
          peer-to-peer money transfer service; each participant pays the merchant directly.
        </p>
        <p
          data-testid="footer-copyright-text"
          className="mt-4 font-mono-ui text-xs text-muted-foreground"
        >
          MONOE © 2026 MONOE Pay LLC. All rights reserved.
        </p>
      </div>
    </div>
  </footer>
);
